import {Role} from './role';

import {Customer} from './customer';
import {environment} from '../../../environments/environment';
import {Department} from './department';

export class User {

    id: number = 0;
    user_id = -1;
    name: string = '';
    email: string = '';
    department_id = 0;
    password: string = '';
    roles: Role[] = [];
    avatar_url: string = '';
    phone_ext: string = '';
    phone: string = '';
    customer: Customer = new Customer();
    department: Department = new Department();
    fullname2 = null;//a hack for the search

    getAvatar() {

        this.avatar_url = environment.baseAPI2 + '/' + 'user/avatar/' + this.id;

    }

}
